import { render, staticRenderFns } from "./DashboardEnrollmentCurrentPlan.vue?vue&type=template&id=30bfde76&"
import script from "./DashboardEnrollmentCurrentPlan.vue?vue&type=script&lang=js&"
export * from "./DashboardEnrollmentCurrentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports